import React from 'react';
import {
  Grid, Typography, TextField,
} from '@mui/material';
import { NumericFormat } from 'react-number-format';
import { useFormikContext } from 'formik';
import _ from 'lodash';
import { WIZARD_QUESTIONS, FILING_STATUS } from '../../../../constants';

const FourthStep = () => {
  const { setFieldValue, errors, values } = useFormikContext();
  const [initialSocialSecurityBenefit, setInitialSocialSecurityBenefit] = React.useState(_.get(values, 'benefitEstimator.initialSocialSecurityBenefit'));
  const [spouseInitialSocialSecurityBenefit, setSpouseInitialSocialSecurityBenefit] = React.useState(_.get(values, 'benefitEstimator.spouseInitialSocialSecurityBenefit'));
  const filingStatus = _.get(values, 'benefitEstimator.filingStatus');

  const handlerInitialSocialSecurityBenefit = (value) => {
    setInitialSocialSecurityBenefit(value);
    setFieldValue('benefitEstimator.initialSocialSecurityBenefit', value);
  };

  const handlerSpouseInitialSocialSecurityBenefit = (value) => {
    setSpouseInitialSocialSecurityBenefit(value);
    setFieldValue('benefitEstimator.spouseInitialSocialSecurityBenefit', value);
  };

  return (
    <Grid container direction='column' spacing={2}>
      <Typography className='steps-wizard-steps question-text'>
        {
                    filingStatus === FILING_STATUS.SINGLE
                      ? WIZARD_QUESTIONS.MONTHLYSSBENEFITS.SINGLE
                      : WIZARD_QUESTIONS.MONTHLYSSBENEFITS.JOINT
                }
      </Typography>
      <Typography className='steps-wizard-steps question-desc'>
        This is your current Social Security benefit if you are already
        receiving benefits. If you have not yet begun receiving benefits,
        this is your estimated initial Social Security benefit which you
        can find on your Social Security Statement or the
        {' '}
        <a className='question-link' href='https://www.ssa.gov/OACT/quickcalc' target='_blank' rel='noreferrer'>Social Security quick calculator</a>
        .
      </Typography>
      <Grid container alignItems='flex-end'>
        {
          filingStatus === FILING_STATUS.SINGLE
            ? (
              <NumericFormat
                value={+initialSocialSecurityBenefit}
                className='steps-wizard-steps answer-input answer-input-mt answer-input-medium'
                customInput={TextField}
                inputProps={{
                  maxLength: 8,
                }}
                thousandSeparator
                prefix='$'
                error={_.has(errors, 'benefitEstimator.initialSocialSecurityBenefit')}
                helperText={_.get(errors, 'benefitEstimator.initialSocialSecurityBenefit')}
                required
                onValueChange={(numberFormatValues) => {
                  const { value } = numberFormatValues;
                  handlerInitialSocialSecurityBenefit(value);
                }}
              />
            )
            : (
              <>
                <Grid item xs={12} sm={6} md={7}>
                  <Typography className='steps-wizard-steps answer-text fixed-min-width'>
                    Your [Current/Estimated] Social Security Benefit
                  </Typography>
                  <NumericFormat
                    value={+initialSocialSecurityBenefit}
                    name='initialSocialSecurityBenefit'
                    className='steps-wizard-steps answer-input answer-input-mt answer-input-medium error-message-sm'
                    customInput={TextField}
                    inputProps={{
                      maxLength: 8,
                    }}
                    thousandSeparator
                    prefix='$'
                    error={_.has(errors, 'benefitEstimator.initialSocialSecurityBenefit')}
                    helperText={_.get(errors, 'benefitEstimator.initialSocialSecurityBenefit')}
                    required
                    onValueChange={(numberFormatValues) => {
                      const { value } = numberFormatValues;
                      handlerInitialSocialSecurityBenefit(value);
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={5}>
                  <Typography className='steps-wizard-steps answer-text fixed-min-width last-amount-input-label-width'>
                    Your Spouse&apos;s [Current/Estimated] Social Security Benefit
                  </Typography>
                  <NumericFormat
                    value={+spouseInitialSocialSecurityBenefit}
                    name='spouseInitialSocialSecurityBenefit'
                    className='steps-wizard-steps answer-input answer-input-mt answer-input-medium error-message-lg'
                    customInput={TextField}
                    inputProps={{
                      maxLength: 8,
                    }}
                    thousandSeparator
                    prefix='$'
                    error={_.has(errors, 'benefitEstimator.spouseInitialSocialSecurityBenefit')}
                    helperText={_.get(errors, 'benefitEstimator.spouseInitialSocialSecurityBenefit')}
                    required
                    onValueChange={(numberFormatValues) => {
                      const { value } = numberFormatValues;
                      handlerSpouseInitialSocialSecurityBenefit(value);
                    }}
                  />
                </Grid>
              </>
            )
        }
      </Grid>
    </Grid>
  );
};

export default FourthStep;
